import classNames from 'classnames';
import is from 'is_js';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef } from 'react';
import { Collapse, Nav, Navbar } from 'reactstrap';
import bgNavbarImg from '../../assets/img/generic/bg-navbar.png';
import { navbarBreakPoint, topNavbarBreakpoint } from '../../config';
import AppContext from '../../context/Context';
import routes from '../../routes';
import Flex from '../common/Flex';
import NavbarTopDropDownMenus from './NavbarTopDropDownMenus';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import ToggleButton from './ToggleButton';
import LogoVertical from './LogoVertical';
import Logo from './Logo';

const NavbarVertical = ({ navbarStyle, currentuserdata, organizationLogo }) => {
  const navBarRef = useRef(null);

  const {
    showBurgerMenu,
    isNavbarVerticalCollapsed,
    setIsNavbarVerticalCollapsed,
    isCombo,
    setShowBurgerMenu,
    setNavbarCollapsed
  } = useContext(AppContext);

  const HTMLClassList = document.getElementsByTagName('html')[0].classList;

  if (isNavbarVerticalCollapsed) {
    HTMLClassList.add('navbar-vertical-collapsed');
  }

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    return () => {
      HTMLClassList.remove('navbar-vertical-collapsed-hover');
    };
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  let time = null;
  const handleMouseEnter = () => {
    if (isNavbarVerticalCollapsed) {
      time = setTimeout(() => {
        HTMLClassList.add('navbar-vertical-collapsed-hover');
      }, 100);
    }
  };

  return (
    <>
      {showBurgerMenu && (
        <div
          onClick={() => setShowBurgerMenu(false)}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 1018,
            background: 'rgba(0,0,0,0.35)'
          }}
        />
      )}
      <Navbar
        expand={navbarBreakPoint}
        className={classNames('navbar-vertical navbar-glass', {
          [`navbar-${navbarStyle}`]: navbarStyle !== 'transparent'
        })}
        light
      >
        <Flex align="center" style={{ position: 'relative', zIndex: '9999' }}>
          <ToggleButton
            isNavbarVerticalCollapsed={isNavbarVerticalCollapsed}
            setIsNavbarVerticalCollapsed={setIsNavbarVerticalCollapsed}
          />
          <Logo
            at={'navbar-vertical'}
            width={180}
            currentuserdata={currentuserdata}
            organizationLogo={organizationLogo}
            isNavbarVerticalCollapsed={isNavbarVerticalCollapsed}
          />
        </Flex>

        <Collapse
          navbar
          isOpen={showBurgerMenu}
          className="scrollbar"
          innerRef={navBarRef}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={() => {
            clearTimeout(time);
            HTMLClassList.remove('navbar-vertical-collapsed-hover');
          }}
          style={{
            ...(navbarStyle === 'vibrant' && {
              backgroundImage: `linear-gradient(-45deg, rgba(0, 160, 255, 0.86), #0048a2),url(${bgNavbarImg})`
            }),
            ...(window.innerWidth < 992 && {
              position: 'fixed',
              top: 0,
              left: 0,
              width: '280px',
              height: '100vh',
              overflowY: 'auto',
              zIndex: 1030,
              boxShadow: '2px 0 12px rgba(0,0,0,0.2)'
            })
          }}
        >
          <Nav navbar vertical>
            {!isNavbarVerticalCollapsed && (
              <LogoVertical
                at={'navbar-vertical'}
                width={180}
                currentuserdata={currentuserdata}
                organizationLogo={organizationLogo}
              />
            )}
            <NavbarVerticalMenu routes={routes} />
          </Nav>
          <div className="settings px-3 px-xl-0">
            {isCombo && (
              <div className={`d-${topNavbarBreakpoint}-none`}>
                <div className="navbar-vertical-divider">
                  <hr className="navbar-vertical-hr my-2" />
                </div>
                <Nav navbar>
                  <NavbarTopDropDownMenus setNavbarCollapsed={setNavbarCollapsed} setShowBurgerMenu={setShowBurgerMenu} />
                </Nav>
              </div>
            )}
            <div className="navbar-vertical-divider">
              <hr className="navbar-vertical-hr my-2" />
            </div>
          </div>
        </Collapse>
      </Navbar>
    </>
  );
};

NavbarVertical.protoTypes = {
  navbarStyle: PropTypes.string
};

NavbarVertical.defaultProps = {
  navbarStyle: 'transparent'
};

export default NavbarVertical;
